import { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
// import { BarChart
// , Bar, XAxis, YAxis, Tooltip, Legend, LabelList, ResponsiveContainer } from "recharts";
import { ChevronLeft, ChevronRight } from "lucide-react";
import "./DashBoardDetails.css";
import Layout from "../Components/Layout";
import Header from "../Components/common/Header";
import { Icon } from "@iconify/react";
import axios from "axios";
import { useLocation, useParams } from "react-router-dom";
import EmployeeInfo from "./EmployeeDetails/EmployeeInfo";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { getWeek } from "date-fns";
import { getUserRole } from "../App";

const getDaysInMonth = (year, month) => {
  return new Date(year, month + 1, 0).getDate();
};

const parseHours = (timeStr) => {
  const [hrs, mins, secs] = timeStr.split(":").map(Number);
  return +(hrs + mins / 60 + secs / 3600).toFixed(2);
};

const DashBoardDetails = () => {
  // const { empId } = useParams();
  const location = useLocation();
  const empId = location.state?.empId;
  const [attendanceList, setAttendanceList] = useState([]);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [totalLeves, setTotalLeves] = useState();
  const [usedLeaves, setUsedLeaves] = useState();
  const [dashboardData, setDashboardData] = useState();
  const [leaveSummary, setLeaveSummary] = useState({
    totalLeaves: 0,
    leavesTaken: 0,
    remainingLeaves: 0,
  });

  const [loading, setLoading] = useState(true);

  const today = new Date();
  const monthName = currentMonth.toLocaleString("default", { month: "long" });
  const year = currentMonth.getFullYear();
  const daysInMonth = getDaysInMonth(year, currentMonth.getMonth());
  const startDay = new Date(year, currentMonth.getMonth(), 1).getDay();

  const featchTotalLeaves = async () => {
    try {
      
      const token = localStorage.getItem("token"); // Or however you're storing it
      const { roles = [], expiryTime } = getUserRole(token);
      console.log(roles,"role oof the login user in emp dashboard")
      if (true) {
      let response;
    if (roles.includes("ROLE_EMP")) {
      // Employee sees their own leave balance
      response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/leave-balance/my`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    } else {
      // Manager/Admin fetches leave balance for a specific employee
      response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/leave-balance/${empId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    }
        console.log("leaves titao", response);
        const data = response.data;

        // Calculate total leaves by summing all allocated leaves
        const totalAllocated =
          (data.totalAllocatedSickLeave || 0) +
          (data.totalAllocatedCasualLeave || 0) +
          (data.totalAllocatedEarnedLeave || 0);
        console.log(totalAllocated, "total allocated");

        // Calculate remaining leaves by summing all remaining leaves
        const totalRemaining =
          (data.remainingSickLeave || 0) +
          (data.remainingCasualLeave || 0) +
          (data.remainingEarnedLeave || 0);
        console.log(totalRemaining, "total remaining");
        // Leaves taken = total allocated - remaining
        const leavesTaken = totalAllocated - totalRemaining;
        setTotalLeves(response.data?.totalAllocatedLeave);
        setLeaveSummary({
          totalLeaves: totalAllocated,
          leavesTaken: leavesTaken,
          remainingLeaves: totalRemaining,
        });
        setUsedLeaves(response.data?.remainingTotalLeaveBalance);
      } else {
        const response = await axios.get(
          // `${process.env.REACT_APP_BACKEND_URL}/api/v1/emps/leave-balance/my`,
           `${process.env.REACT_APP_BACKEND_URL}/api/v1/leave-bal`,

          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        // console.log("leaves titao", response);
        setTotalLeves(response.data?.totalAllocatedLeave);
        // setUsedLeaves(response.data?.remainingTotalLeaveBalance);
        const data = response.data;

        // Calculate total leaves by summing all allocated leaves
        const totalAllocated =
          (data.totalAllocatedSickLeave || 0) +
          (data.totalAllocatedCasualLeave || 0) +
          (data.totalAllocatedEarnedLeave || 0);

        // Calculate remaining leaves by summing all remaining leaves
        const totalRemaining =
          (data.remainingSickLeave || 0) +
          (data.remainingCasualLeave || 0) +
          (data.remainingEarnedLeave || 0);

        // Leaves taken = total allocated - remaining
        const leavesTaken = totalAllocated - totalRemaining;

        setLeaveSummary({
          totalLeaves: totalAllocated,
          leavesTaken: leavesTaken,
          remainingLeaves: totalRemaining,
        });
      }
    } catch (error) {
      console.error("Error fetching leave records:", error);
    }
  };

  const monthNameToNumber = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

  const featchDasboardData = async (month, year) => {
      setLoading(true); // start skeleton
    try {
      const token = localStorage.getItem("token"); // Or however you're storing it
      if (empId) {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets/employees/monthly/${empId}`,

          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("dashboard", response.data);
        setDashboardData(response.data);
      } else {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/timesheets/my/monthly?month=${month}&year=${year}`,

          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        console.log("dashboard", response.data);
        setDashboardData(response.data);
      }
    } catch (error) {
      console.error("Error fetching leave records:", error);
    } finally {
      setLoading(false); // stop skeleton
    }
  };

  useEffect(() => {
     // Convert month name to number using mapping
  const month = monthNameToNumber[monthName]; 
    featchDasboardData(month, year);
  }, [monthName, year]);
  useEffect(() => {
    featchTotalLeaves();
  }, []);

  const handleNewEntry = (newEntry) => {
    setAttendanceList([newEntry, ...attendanceList]);
  };

  const goToPreviousMonth = () => {
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() - 1, 1)
    );
  };

  const goToNextMonth = () => {
    setCurrentMonth(
      new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 1)
    );
  };

  // 🧠 Transform dailyTimesheets into weekly grouped dataset for chart
  const grouped = {};
  const month = currentMonth.getMonth();

  // Sort and filter by current month
  const filtered = (dashboardData?.dailyTimesheets || [])
    .filter((entry) => {
      const d = new Date(entry.date);
      return d.getMonth() === month && d.getFullYear() === year;
    })
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  filtered.forEach((entry) => {
    const dateObj = new Date(entry.date);
    const dayLabel = dateObj.toLocaleDateString("en-US", { weekday: "short" });

    if (dayLabel === "Sat" || dayLabel === "Sun") return; // skip weekends

    const diffToMonday = dateObj.getDay() === 0 ? -6 : 1 - dateObj.getDay();
    const monday = new Date(dateObj);
    monday.setDate(dateObj.getDate() + diffToMonday);
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 4); // only Mon–Fri

    const label = `${monday.toLocaleDateString("en-US", {
      month: "short",
      day: "2-digit",
    })}–${sunday.toLocaleDateString("en-US", { day: "2-digit" })}`;

    if (!grouped[label]) grouped[label] = { week: label };
    grouped[label][dayLabel] = entry.totalDailyHours;
  });

  const chartData = Object.values(grouped);

  console.log("empId from URL:", empId);

  return (
    <Layout>
      <div className="">
        {empId ? (
          <EmployeeInfo empId={empId} />
        ) : (
          <Header onNewEntry={handleNewEntry} />
        )}
        {/* <Header onNewEntry={handleNewEntry} /> */}
        {/* Statistic Cards */}
        <div className="row mt-3">
          <div className="col-12 col-lg-4 mb-3">
          <div className="stat-card ">
            <div className="stat-icon blue">
              <Icon icon="mingcute:time-line" className="icon fs-4" />
            </div>
            <div className="stat-info">
              <p className="stat-label">Total Hours</p>
              <p className="stat-value">
                {/* {dashboardData?.totalMonthlyHours ?? "0"} */}
                 <p className="stat-value">
          {loading ? <Skeleton width={80} height={20} /> : dashboardData?.formattedTotalMonthlyHours ?? "0"}
        </p>
              </p>
            </div>
          </div>
          </div>

 <div className="col-12 col-lg-4 mb-3">
          <div className="stat-card ">
            <div className="stat-icon yellow">
              <Icon icon="mingcute:time-line" className="icon fs-4" />
            </div>
            <div className="stat-info">
              <p className="stat-label">Average Daily Hours</p>
              <p className="stat-value">
                {/* {dashboardData?.avgDailyHours ?? "5"} */}
                 <p className="stat-value">
          {loading ? <Skeleton width={80} height={20} /> : dashboardData?.formattedAvgDailyHours ?? "0"}
        </p>
              </p>
            </div>
          </div>
          </div>
          <div className="col-12 col-lg-4 mb-3">
            <div className="stat-card  ">
              <div className="stat-icon green">
                <Icon
                  icon="material-symbols:event-outline-rounded"
                  className="icon fs-4"
                />
              </div>
              <div className="stat-info">
                <p className="stat-label">Leaves</p>
                {/* <p className="stat-value">
              
                  
                  {leaveSummary.leavesTaken}
                  {" "}
                <span className="stat-subvalue">/{leaveSummary.totalLeaves}</span>
              </p> */}
                <p className="stat-value">
                  {loading ? (
                    <Skeleton width={100} height={20} />
                  ) : (
                    <>
                      {leaveSummary.leavesTaken}{" "}
                      <span className="stat-subvalue">
                        /{leaveSummary.totalLeaves}
                      </span>
                    </>
                  )}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Bar Chart & Calendar */}
        <div className="chart-calendar-wrapper">
          <div className="chart-section">
            <h2 className="chart-title">Weekly Grouped Hours</h2>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  height: "320px",
                  gap: "8px",
                  padding: "0 16px",
                }}
              >
                {Array(5)
                  .fill(0)
                  .map((_, i) => (
                    <div
                      key={i}
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        gap: "4px",
                      }}
                    >
                      {Array(5)
                        .fill(0)
                        .map((_, j) => (
                          <Skeleton
                            key={j}
                            width="100%"
                            height={`${Math.random() * 60 + 20}px`} // random height to simulate bars
                          />
                        ))}
                    </div>
                  ))}
              </div>
            ) : (
              <BarChart
                dataset={chartData}
                xAxis={[{ dataKey: "week", scaleType: "band" }]}
                colors={["#CBF1FF"]}
                series={[
                  {
                    dataKey: "Mon",
                    label: "Mon",
                    valueFormatter: (val) => `${val} hrs`,
                  },
                  {
                    dataKey: "Tue",
                    label: "Tue",
                    valueFormatter: (val) => `${val} hrs`,
                  },
                  {
                    dataKey: "Wed",
                    label: "Wed",
                    valueFormatter: (val) => `${val} hrs`,
                  },
                  {
                    dataKey: "Thu",
                    label: "Thu",
                    valueFormatter: (val) => `${val} hrs`,
                  },
                  {
                    dataKey: "Fri",
                    label: "Fri",
                    valueFormatter: (val) => `${val} hrs`,
                  },
                ]}
                height={320}
                 sx={{
                  
    "& .MuiBarElement-root": {
      rx: 10,   // rounds all
      ry: 10,
      transform: "translateY(-1px)",   // pulls bar UP slightly
    },
    "& .MuiBarElement-root": {
      clipPath: "inset(0 0 0 round 10px 10px 0 0)", // top only
    },
    "& .MuiBarElement-root:hover": {
    fill: "#38BDF8", // hover color
    transform: "translateY(-6px) scaleY(1.05)",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  "& .MuiChartAxis-root .MuiChartAxis-tickLabel": {
    fontSize: "0.75rem",
    fontWeight: 500,
    fill: "#64748B", // slate-500
  },
  "& .MuiChartAxis-root .MuiChartAxis-line": {
    stroke: "#CBD5E1", // slate-200
  },
  "& .MuiChartLegend-root": {
    marginTop: "12px",
    fontSize: "0.875rem",
    fontWeight: 600,
    color: "#334155", // slate-700
  },
  }}



              />
            )}
          </div>

          {/* Calendar */}
          <div className="calendar-section">
            <div className="calendar-header">
              <p className="secondchart-title">Attendance</p>
              <div className="month-navigation">
                <button className="nav-btn left" onClick={goToPreviousMonth}>
                  <ChevronLeft size={18} />
                </button>
                <span className="calendar-title">
                  {monthName} {year}
                </span>
                <button className="nav-btn right" onClick={goToNextMonth}>
                  <ChevronRight size={18} />
                </button>
              </div>
            </div>

            {/* <div className="days-grid"> */}
            <div className="days-container">
              {["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"].map((day) => (
                <div key={day} className="day-cell">
                  {day}
                </div>
              ))}
            </div>

            {/* <div className="calendar-days"> */}
            <div className="dates-grid">
              {loading ? (
                Array(daysInMonth + (startDay === 0 ? 6 : startDay - 1))
                  .fill(null)
                  .map((_, i) => (
                    <div
                      key={`skeleton-${i}`}
                      className="date-cell skeleton-cell"
                      style={{
                        backgroundColor: "#e0e0e0",
                        borderRadius: "4px",
                        minHeight: "40px",
                      }}
                    >
                      <Skeleton width="100%" height="100%" />
                    </div>
                  ))
              ) : (
                <>
                  {Array(startDay === 0 ? 6 : startDay - 1)
                    .fill(null)
                    .map((_, i) => (
                      <div key={`empty-${i}`} className="date-cell empty"></div>
                    ))}

                  {Array(daysInMonth)
                    .fill(null)
                    .map((_, i) => {
                      const date = i + 1;
                      const fullDate = new Date(
                        year,
                        currentMonth.getMonth(),
                        date
                      );
                      const formattedDate =
                        fullDate.toLocaleDateString("en-CA");
                      const isWeekend =
                        fullDate.getDay() === 0 || fullDate.getDay() === 6;
                      const isToday =
                        fullDate.toDateString() === today.toDateString();
                      const isPunchedIn = (
                        dashboardData?.dailyTimesheets || []
                      ).some(
                        (entry) =>
                          new Date(entry.date).toLocaleDateString("en-CA") ===
                          formattedDate
                      );
                      // const isHoliday = customHolidays.includes(formattedDate);

                      return (
                        <div
                          key={date}
                          className={`date-cell 
                      ${isPunchedIn ? "punched-in" : ""} 
                      ${isWeekend ? "weekend" : ""} 
                      ${isToday ? "today" : ""} 
                     `}
                        >
                          {date}
                        </div>
                      );
                    })}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default DashBoardDetails;
